import { WsColors } from 'wisestep-base';

const RoundPin = ({ color = WsColors.GreyBlack }: { color?: string }) => (
  <svg
    width="13.5"
    height="19"
    viewBox="0 0 13.5 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.12503 1.625C1.12503 1.00273 1.62776 0.5 2.25003 0.5H11.25C11.8723 0.5 12.375 1.00273 12.375 1.625C12.375 2.24727 11.8723 2.75 11.25 2.75H10.2129L10.6137 7.96016C11.9039 8.65977 12.9235 9.83047 13.4086 11.2895L13.4438 11.3949C13.5598 11.7395 13.5 12.1156 13.2891 12.4074C13.0782 12.6992 12.7371 12.875 12.375 12.875H1.12503C0.76292 12.875 0.42542 12.7027 0.210967 12.4074C-0.00348621 12.1121 -0.0597362 11.7359 0.0562794 11.3949L0.0914356 11.2895C0.576592 9.83047 1.59612 8.65977 2.88636 7.96016L3.28714 2.75H2.25003C1.62776 2.75 1.12503 2.24727 1.12503 1.625ZM5.62503 14H7.87503V17.375C7.87503 17.9973 7.37229 18.5 6.75003 18.5C6.12776 18.5 5.62503 17.9973 5.62503 17.375V14Z"
      fill={color}
    />
  </svg>
);

export default RoundPin;
